// removed by extract-text-webpack-plugin
module.exports = {"container":"_2avmN"};


//////////////////
// WEBPACK FOOTER
// ./app/components/animated-loader/animated-loader-container.scss
// module id = 966
// module chunks = 0 3 4 5 6